import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './ErrorBoundary';

// Игнорируем ошибки от расширений браузера (MetaMask и т.д.)
window.addEventListener('error', (event) => {
  if (
    event.message?.includes('MetaMask') ||
    event.message?.includes('chrome-extension') ||
    event.message?.includes('Failed to connect to MetaMask') ||
    event.filename?.includes('chrome-extension') ||
    event.filename?.includes('inpage.js')
  ) {
    console.warn('Browser extension error ignored:', event.message);
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
}, true); // Используем capture phase для перехвата ошибок

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const reasonStr = reason?.message || reason?.toString() || '';
  const reasonStack = reason?.stack || '';
  
  if (
    reasonStr.includes('MetaMask') ||
    reasonStr.includes('chrome-extension') ||
    reasonStr.includes('Failed to connect to MetaMask') ||
    reasonStack.includes('chrome-extension') ||
    reasonStack.includes('inpage.js')
  ) {
    console.warn('Browser extension promise rejection ignored:', reason);
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
